import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { Plus, Edit, Trash2, X, AlertCircle, Loader, Paperclip, Banknote, Coins, Calculator, CircleMinus, CirclePlus } from 'lucide-react';
import { useToast } from "../components/ui/toast-provider";

// Servicios
import { CambiosCierreService } from "../services/cambiosCierreService";
// Tipos de Response
import { CambiosCierreResponse} from "../types/cambiosCierre";
import { EmpleadoService } from "../services/empleadoService";
import { set } from "zod";

export default function DetalleCambiosCierre({ isOpen, onClose, idEditando }: { isOpen: boolean; onClose: () => void; idEditando: number }) {

    const [isLoading, setIsLoading] = useState(true);
    const [cambiosCierres, setcambiosCierres] = useState<CambiosCierreResponse[]>([]);
    const [error, setError] = useState("");
    const [fecha, setFecha] = useState("");

    const { addToast } = useToast();

    const cargarCambiosCierre = async (id: number) => {
        try {
            setIsLoading(true);
            const response = await CambiosCierreService.getByAgente(id);
            setcambiosCierres(response.data);
            //console.log("Cambios de cierre cargados:", response.data);
        } catch (err) {
            console.error("Error al cargar cambiosCierre: " + err);
        } finally {
            setIsLoading(false);
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if(!fecha) {
            setError("La fecha es requerida");
            return;
        }

        if (fecha >= hoy) {
            setError("No puedes seleccionar el día de hoy o una fecha futura");
            return;
        }

        try {
            await CambiosCierreService.crear({
                idAgente: idEditando,
                fecha: fecha
            });

            addToast("Fecha de cambio registrada exitosamente");
            setFecha("");
            setError("");
            cargarCambiosCierre(idEditando);
        } catch (err:any) {
              const message =
                err?.response?.data?.message ||
                "Error inesperado al guardar agente";

            setError(message);
        }
    }

    const hoy = new Date().toISOString().split("T")[0];

    const cambiarEstado = async (id: number) => {
        try {
        setIsLoading(true);
            await CambiosCierreService.desactivar(id);
            await cargarCambiosCierre(idEditando);
        } catch (err) {
        setError("Error al cambiar estado del empleado");
        } finally {
        setIsLoading(false);
        }
    };


    useEffect(() => {
        if(isOpen) {
            if (idEditando !== 0) {
                cargarCambiosCierre(idEditando);
            }
            setError("");
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }
    return (
        <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-50">
            <div className="rounded-2xl w-full max-w-2xl shadow-lg relative max-h-[90vh] overflow-y-auto scrollbar-thin">
                <Card>
                    <CardHeader className="flex flex-row items-center justify-between">
                        <CardTitle>{'Cambios de Cierres Anteriores'}</CardTitle>
                        <button
                        onClick={onClose}
                        className="p-2 hover:bg-destructive/10 rounded-lg transition-colors"
                        >
                        <X className="w-5 h-5 text-destructive" />
                        </button>
                    </CardHeader>
                    <CardContent>
                        <div className="space-y-4">
                            {isLoading ? (
                                <div className="flex items-center justify-center py-8">
                                    <Loader className="w-6 h-6 animate-spin text-primary mr-2" />
                                    <p>Cargando cambios de cierres...</p>
                                </div>
                                ) : cambiosCierres.length === 0 ? (
                                <div className="text-center py-8">
                                    <p className="text-muted-foreground">No hay cambios asignados a los cierres para mostrar</p>
                                </div>
                                ) : (
                                <div className="overflow-auto max-h-[400px] border-gray-400 mb-10">
                                    <table className="min-w-full text-left">
                                    <thead className="bg-primary text-white sticky top-0">
                                        <tr>
                                        <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Fecha</th>
                                        <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Estado</th>
                                        <th className="px-3 md:px-4 py-2 md:py-3 text-center font-semibold">Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {cambiosCierres.map((cierre) => (
                                        <tr key={cierre.idCambiosCierre} className="border-t border-border hover:bg-muted/30 transition-colors">
                                            <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">{cierre.fecha.slice(0,10).split("-").reverse().join("/")}</td>
                                            <td className={`px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm ${cierre.activo ? 'text-accent' : 'text-destructive'}`}>
                                                {cierre.activo ? 'Activo' : 'Desactivado'}
                                            </td>
                                            <td className="px-3 md:px-4 py-2 md:py-3">
                                            <div className="flex justify-center gap-1 md:gap-2">
                                                <Button
                                                size="sm"
                                                variant="destructive"
                                                className="text-xs md:text-sm px-2 md:px-3"
                                                onClick={() => {
                                                    cambiarEstado(Number(cierre.idCambiosCierre));
                                                }}
                                                disabled = {cierre.activo ? false : true}
                                                >
                                                    <CircleMinus size={16} />
                                                </Button>
                                            </div>
                                            </td>
                                        </tr>
                                        ))}
                                    </tbody>
                                    </table>
                                </div>)}

                            <div className='grid grid-cols-1 md:grid-cols-2 gap-4 items-end mt-10'>  
                                <Input
                                    label="Fecha de Cambio:"
                                    type="date"
                                    value={fecha}
                                    max={hoy}
                                    onChange={(e) => setFecha(e.target.value)}
                                    required
                                />
                                <Button type="submit" variant="primary" onClick={handleSubmit}>
                                    {'Asignar Nueva Fecha'}
                                </Button>
                            </div>
                            <div className = "flex justify-center">
                            {error && (
                                <span className="text-destructive text-center text-sm">{error}</span>
                            )}
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    )

}